import { __decorate } from "tslib";
import { LitElement, html, customElement, internalProperty } from 'lit-element';
import '@cds/core/datalist/register.js';
import { getData, filter } from './utils';
let DemoFiltering = class DemoFiltering extends LitElement {
    constructor() {
        super(...arguments);
        this.data = getData();
        this.filteredList = [];
        this.search = '';
        this.idFilterOpen = false;
    }
    render() {
        return html `
      <cds-grid>
        <cds-grid-column>
          Stock
          <cds-inline-button id="id-filter-demo" @click=${() => this.idFilterOpen = true} aria-label="filter column" cds-layout="align:right">
            <cds-icon shape="filter"></cds-icon>
          </cds-inline-button>
          <cds-dropdown ?hidden=${!this.idFilterOpen} @hiddenChange=${() => this.idFilterOpen = false} anchor="#id-filter-demo">
            <cds-datalist>
              <label cds-layout="display:screen-reader-only">search</label>
              <input type="text" placeholder="Search" @input=${e => this.search = e.target.value} />
              <datalist>
                ${this.data.map(entry => html `<option value="${entry.id}"></option>`)}
              </datalist>
            </cds-datalist>
          </cds-dropdown>
        </cds-grid-column>
        <cds-grid-column>Average</cds-grid-column>
        <cds-grid-column>Current</cds-grid-column>
        <cds-grid-column>About</cds-grid-column>
        ${this.filteredList.map(entry => html `
          <cds-grid-row>
            <cds-grid-cell>${entry.id}</cds-grid-cell>
            <cds-grid-cell>$${entry.average}</cds-grid-cell>
            <cds-grid-cell>$${entry.value}</cds-grid-cell>
            <cds-grid-cell>${entry.about}</cds-grid-cell>
          </cds-grid-row>
        `)}
        <cds-grid-footer></cds-grid-footer>
      </cds-grid>
    `;
    }
    updated(props) {
        super.updated(props);
        if (props.has('search') && props.get('search') !== this.search) {
            this.filteredList = filter([...this.data], 'id', this.search);
        }
    }
    createRenderRoot() {
        return this;
    }
};
__decorate([
    internalProperty()
], DemoFiltering.prototype, "data", void 0);
__decorate([
    internalProperty()
], DemoFiltering.prototype, "filteredList", void 0);
__decorate([
    internalProperty()
], DemoFiltering.prototype, "search", void 0);
__decorate([
    internalProperty()
], DemoFiltering.prototype, "idFilterOpen", void 0);
DemoFiltering = __decorate([
    customElement('demo-filtering')
], DemoFiltering);
export { DemoFiltering };
//# sourceMappingURL=demo.row-filtering.js.map